import script from "./FinanceMain.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceMain.vue?vue&type=script&setup=true&lang=js"

import "./FinanceMain.vue?vue&type=style&index=0&id=2d049aa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d049aa9"]])

export default __exports__